export const EXPENSE_TYPES_ID_KEY = 'id';
export const EXPENSE_TYPES_CUSTOMER_ID_KEY = 'customer';
export const EXPENSE_TYPES_NAME_KEY = 'expenseName';
export const EXPENSE_TYPES_OWNERSHIP_KEY = 'ownership';
export const EXPENSE_TYPES_IMPORT_CODE_KEY = 'importCode';
export const EXPENSE_TYPES_ACTIVE_KEY = 'active';
export const EXPENSE_TYPES_CREATED_AT_KEY = 'createdAt';
export const EXPENSE_TYPES_CREATED_BY_KEY = 'createdBy';
export const EXPENSE_TYPES_MODIFIED_AT_KEY = 'modifiedAt';
export const EXPENSE_TYPES_MODIFIED_BY_KEY = 'modifiedBy';
export const EXPENSE_TYPES_DETAIL_KEY = 'detail';
export const EXPENSE_TYPES_DELETED_AT_KEY = 'remove';

export const EXPENSE_TYPES_TABLE_KEY = 'v1/costs/types';
export const EXPENSE_TYPES_TABLE_SETTINGS = 'expense_types';
export const EXPENSE_TYPES_QUERY_KEY = 'expenseTypes';

export const TableSettingsKeys = {
  expenseName: 'table_list.columns.expenseTypes.expenseName',
  customer: 'table_list.columns.customerId',
  importCode: 'table_list.columns.expenseTypes.importCode',
  ownership: 'table_list.columns.expenseTypes.ownership',
  active: 'table_list.columns.expenseTypes.active',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
